import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

// Safari throws on storage access (and on writes in private mode) when cookies
// are blocked. Signup only needs the state to survive route changes, so falling
// back to memory keeps the flow usable.
function createMemoryStorage() {
	const values = {}
	return {
		getItem: (key) => (key in values ? values[key] : null),
		setItem: (key, value) => {
			values[key] = String(value)
		},
		removeItem: (key) => {
			delete values[key]
		},
	}
}

// Memory storage does not survive a reload, so anything that reloads the page
// to apply state has to check this first
export let storageSurvivesReload = true

function getStorage() {
	try {
		const storage = window.sessionStorage || window.localStorage
		const probeKey = 'partner-signup-storage-probe'
		storage.setItem(probeKey, '1')
		storage.removeItem(probeKey)
		return storage
	} catch (e) {
		console.warn('persistent storage unavailable, keeping signup state in memory', e)
		storageSurvivesReload = false
		return createMemoryStorage()
	}
}

const vuexLocal = new VuexPersistence({
	storage: getStorage(),
	key: 'partner-signup',
})

function getInitialState() {
	return {
		country: null,
		city: null,
		name: null,
		type: null,
		username: '',
		password: '',
		showPassword: null,
		email: '',
		phone: '',
		contactName: '',
		preferredLanguageCode: '',
		acceptToTermsOfUse: null,
		description: '',
		website: '',
		address: '',
		postalCode: '',
		vatNumber: '',
		latitude: null,
		longitude: null,
		monFetchStart: null,
		tueFetchStart: null,
		wedFetchStart: null,
		thuFetchStart: null,
		friFetchStart: null,
		satFetchStart: null,
		sunFetchStart: null,
		monFetchEnd: null,
		tueFetchEnd: null,
		wedFetchEnd: null,
		thuFetchEnd: null,
		friFetchEnd: null,
		satFetchEnd: null,
		sunFetchEnd: null,
		emailNotInCity: null,
		googleVenueId: null,
		venueExists: null,
	}
}

export default new Vuex.Store({
	state: getInitialState,
	mutations: {
		clearAll(state) {
			let initialState = getInitialState()
			Object.keys(initialState).forEach((key) => {
				state[key] = initialState[key]
			})
		},
		setPartnerDataValue(state, { key, value }) {
			if (!Object.getOwnPropertyDescriptor(state, key))
				throw new Error(`setPartnerDataValue invalid key ${key}`)

			state[key] = value
		},
	},
	actions: {
		setPartnerDataValue({ commit }, { key, value }) {
			commit('setPartnerDataValue', { key, value })
		},
		clearAll({ commit }) {
			commit('clearAll')
		},
	},
	plugins: [vuexLocal.plugin],
})
